/**
 * Global
 * ------
 */

$('figure.alignnone').each(function () {
    $(this).find('img').wrap('<div class="image-wrapper"></div>');
});

$('img.alignnone').each(function () {
    if(!$(this).parent('figure').length) {
        $(this).wrap('<div class="image-wrapper alignnone-image-wrapper"></div>');
    }
});

$('.wp-content blockquote').each(function () {
    if($(this).find('p').html().length > 75) {
        $(this).addClass('extra-long-blockquote');
    }

    if($(this).find('p').length) {
        $(this).addClass('blockquote-style-' + $(this).find('p')[0].style.textAlign);
    }
});

$('.modal').each(function () {
    $("#modal-main-container").append($(this).remove());
});

$('.team-card').on('click', function () {
    $(this).toggleClass('image-flipped');
});